import { VALIDATION_RULES } from '@localstack/services';
import { Box, Radio, RadioGroup, Theme, Typography } from '@mui/material';
import { upperCase } from 'lodash';
import { Control, Controller } from 'react-hook-form';
import { ReactElement } from 'react';
import { EmulatorType } from '@localstack/types';

import { FinishAccountCreationFormData } from '../types';

import { SectionDivider } from './SectionDivider';
import { OptionList, OptionRow, SELECTED_OPTION_CLASS } from './styled';

export type EmulatorChoiceOption = {
  value: EmulatorType;
  headingColor: (theme: Theme) => string;
  icon: ReactElement;
  /** Shown under the row while it is selected. */
  terms: Optional<string>;
};

type Props = {
  control: Control<FinishAccountCreationFormData, any>; // eslint-disable-line
  options: EmulatorChoiceOption[];
};

export const EmulatorChoiceSection = ({ control, options }: Props): ReactElement => (
  <>
    <SectionDivider label="Choose emulator" />
    <Box mt={0.5}>
      <Controller
        rules={VALIDATION_RULES.required}
        control={control}
        name="emulator"
        render={({ field }) => (
          <RadioGroup {...field}>
            <OptionList>
              {options.map((option) => {
                const isSelected = field.value === option.value;

                return (
                  <OptionRow
                    key={option.value}
                    value={option.value}
                    control={<Radio size="small" />}
                    labelPlacement="start"
                    className={isSelected ? SELECTED_OPTION_CLASS : undefined}
                    label={
                      <Box display="flex" flexDirection="column" alignItems="flex-start">
                        <Box display="flex" alignItems="center" gap={0.5} mt={1}>
                          <Typography
                            sx={(theme) => ({ color: option.headingColor(theme) })}
                            fontWeight={600}
                            fontSize={13}
                          >
                            {upperCase(option.value)}
                          </Typography>
                          {option.icon}
                        </Box>
                        {isSelected && option.terms && (
                          <Typography
                            color="text.secondary"
                            mb={1}
                            mt={0.25}
                            fontSize={12}
                            fontWeight={600}
                            lineHeight={1.2}
                          >
                            {option.terms}
                          </Typography>
                        )}
                      </Box>
                    }
                  />
                );
              })}
            </OptionList>
          </RadioGroup>
        )}
      />
    </Box>
  </>
);
